<style scoped>

  .button-cell {
    width: 50px;
  }

</style>

<template>
  
  <div>

    <div class="ui segment">
      <h4 class="ui dividing header">Dados do Fechamento</h4>
      <div class="ui form">
        <div class="fields">
          <div class="two wide field">
            <label class="form-label">Data Inicial</label>
            {{ $formatDate(filter.startDate) }}
          </div>
          <div class="two wide field">
            <label class="form-label">Data Final</label>
            {{ $formatDate(filter.endDate) }}
          </div>    
          <div class="five wide field">
            <label class="form-label">Cliente</label>
            {{ customer.name }}
          </div>
          <div class="two wide field">
            <label class="form-label">Período de Pagamento</label>
            {{ paymentPeriod }}
          </div>          
          <div class="two wide field">
            <label class="form-label">Cond. de Pagamento</label>
            {{ paymentCond }}
            <div v-if="weeklyPaymentRule" class="ui small label">
              {{ weeklyPaymentRule }}
            </div>          
          </div>
          <div class="three wide field">
            <label class="form-label">Dia(s) de Vencimento</label>
            <div v-if="paymentDays" class="ui small labels">
              <div v-for="day in paymentDays" class="ui label">{{ day }}</div>
            </div>
            <span v-else>Não definido</span>
          </div> 
        </div>        
        <div class="fields">
          <div class="two wide field">
            <label class="form-label">Laudos Selecionados</label>
            {{ certs.length }}
          </div>
          <div class="three wide field">
            <label class="form-label">Total a Receber</label>
            R$ {{ $formatCurrency(totalInvoiceable) }}
          </div>
        </div>
      </div>
    </div>

    <div v-if="totalInvoiceable" class="ui segment">
      <h4 class="ui dividing header">Vencimentos</h4>
      <button class="ui mini basic button" @click="$refs.receivableModal.create()">
        <i class="plus blue icon"></i> Adicionar
      </button>
      <div v-if="receivablesTotal" class="ui grid m-t-5">
        <div class="eight wide computer sixteen wide tablet sixteen wide mobile column">
          <table class="ui celled selectable tablet stackable table animated fadeIn">
            <thead v-if="$isDesktop">
              <tr>
                <th>Dia da Semana</th>
                <th>Vencimento</th>
                <th>Valor</th>
                <th></th>
              </tr>  
            </thead>
            <tbody>
              <tr v-for="(receivable, index) in receivables" @click="$refs.receivableModal.update(receivable)">
                <td>
                  <strong class="mobile-only">Dia da Semana: </strong> {{ receivable.weekDayLabel }}
                </td>
                <td>
                  <strong class="mobile-only">Vencimento: </strong> {{ $formatDate(receivable.dueDate) }}   
                </td>
                <td>
                  <strong class="mobile-only">Valor: </strong> R$ {{ $formatCurrency(receivable.value) }}
                </td>            
                <td class="button-cell" @click="onRemoveReceivable($event, index)">
                  <button class="ui small icon button">
                    <i class="times icon"></i>
                  </button>
                </td>      
              </tr>                
            </tbody>
            <tfoot>
              <tr>
                <td></td>
                <td></td>
                <td class="bold text">R$ {{ $formatCurrency(receivablesTotal) }}</td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <p v-else class="grey text m-t-30 m-b-30 animated fadeIn">
        <i class="info circle icon"></i> Nenhum vencimento informado
      </p>
    </div>

    <div class="ui segment">                  
      <h4 class="ui dividing header">Serviços</h4>
      <table class="ui celled selectable tablet stackable table">
        <thead v-if="$isDesktop">
          <tr>
            <th>Serviço</th>
            <th>Laudos</th>
            <th>Valor Total</th>
            <th>Total Recebido</th>
            <th v-if="hasAnticipation">Total Antecipado</th>
            <th>Total a Receber</th>
          </tr>  
        </thead>
        <tbody>
          <tr v-for="(service, index) in resume">                            
            <td>
              <strong class="mobile-only">Serviço: </strong> 
              {{ service.description }}
              <span class="ui small label m-l-10">
                <i :class="service.typeIcon"></i>
                {{ service.typeDescription }}
              </span>
            </td>              
            <td>
              <strong class="mobile-only">Laudos: </strong> {{ $formatInteger(service.count) }}   
            </td>
            <td>
              <strong class="mobile-only">Valor Total: </strong> R$ {{ $formatCurrency(service.value) }}
            </td>
            <td>
              <strong class="mobile-only">Total Recebido: </strong> R$ {{ $formatCurrency(service.receivedValue) }}
            </td>
            <td v-if="hasAnticipation">
              <strong class="mobile-only">Total Antecipado: </strong> R$ {{ $formatCurrency(service.anticipationValue) }}
            </td>
            <td>
              <strong class="mobile-only">Total a Receber: </strong> R$ {{ $formatCurrency(service.invoiceableValue) }}
            </td>              
          </tr>                
        </tbody>
        <tfoot>
          <tr>
            <td></td>
            <td class="bold text">{{ $formatInteger(totals.count) }}</td>
            <td class="bold text">R$ {{ $formatCurrency(totals.value) }}</td>
            <td class="bold text">R$ {{ $formatCurrency(totals.receivedValue) }}</td>
            <td v-if="hasAnticipation" class="bold text">R$ {{ $formatCurrency(totals.anticipationValue) }}</td>
            <td class="bold text">R$ {{ $formatCurrency(totals.invoiceableValue) }}</td>
          </tr>
        </tfoot>
      </table>
    </div>

    <div class="ui segment">
      <h4 class="ui dividing header">Laudos</h4>
      <table class="ui celled selectable tablet stackable table">
        <thead v-if="$isDesktop">
          <tr>
            <th>Número</th>
            <th>Data</th>
            <th>Animal</th>
            <th>Tutor</th>
            <th>Colaborador</th>
            <th>Valor Recebido</th>
            <th v-if="hasAnticipation">Valor Antecipado</th>
            <th>Valor a Receber</th>
            <th></th>
          </tr>  
        </thead>
        <tbody>
          <tr v-for="(cert, index) in certs" :class="{ negative: cert.financialStatus == 'pending' }">
            <td>
              <strong class="mobile-only">Número: </strong> 
              <i :class="cert.financialStatusData.icon"></i>
              {{ cert.id }}
            </td>            
            <td>
              <strong class="mobile-only">Data: </strong> {{ $formatDate(cert.date) }}
            </td>
            <td>
              <strong class="mobile-only">Animal: </strong>
              <i v-if="cert.animalSex == 'male'" class="mars blue icon"></i>
              <i v-if="cert.animalSex == 'female'" class="venus pink icon"></i>
              {{ cert.animalName.trim() }}
              <div v-if="cert.registrationId" class="ui small label">
                {{ cert.registrationId }}
              </div>
            </td>
            <td>
              <strong class="mobile-only">Tutor: </strong> 
              {{ cert.ownerName }}                
            </td>            
            <td>
              <strong class="mobile-only">Colaborador: </strong>
              {{ cert.userName }}
            </td>
            <td>
              <strong class="mobile-only">Valor Recebido: </strong> R$ {{ $formatCurrency(cert.receivedValue) }}
            </td>
            <td v-if="hasAnticipation">
              <strong class="mobile-only">Valor Antecipado: </strong> R$ {{ $formatCurrency(cert.anticipationValue) }}
            </td>    
            <td>
              <strong class="mobile-only">Valor a Receber: </strong> R$ {{ $formatCurrency(cert.invoiceableValue) }}   
            </td>
            <td class="button-cell">
              <button class="ui small icon button" @click="showCert($event, cert.id)">
                <i class="search plus icon"></i>
              </button>
            </td>
          </tr>                
        </tbody>
      </table>
    </div>

    <button class="ui basic button" :class="{ disabled: saving }" @click="$emit('onBack')">
      <i class="arrow left icon"></i> Voltar
    </button>

    <button class="ui right floated blue button" :class="{ loading: saving }" @click="onConfirm()">
      <i class="check icon"></i> Confirmar 
    </button>

    <receivable-modal ref="receivableModal" @onCreate="onAddReceivable" @onUpdate="onUpdateReceivable" />

  </div>

</template>

<script>

  import _ from "underscore"  
  import FinancialService from "@/services/financial-service"
  import CustomerInvoiceService from "@/services/customer-invoice-service"
  import DatePicker from "@/components/date-picker"
  import ReceivableModal from "./receivable-modal"
  import { AppBrowser, Calendar, moment, PaymentCondition } from "@/utils"

  export default {
    
    name: "ConfirmationStep",

    data() {
      return {
        saving: false,
        receivables: [],
        service: new CustomerInvoiceService(),
      }
    },

    components: {
      DatePicker,
      ReceivableModal,
    },

    props: ["filter", "customer", "certs", "resume", "totals"],

    created() {
      this.loadReceivables()
    },

    computed: {

      paymentPeriod() {

        const label = this.customer.paymentPeriod == "*" ? "Todos" : FinancialService.PAYMENT_PERIOD[this.customer.paymentPeriod].label

        return label
      },

      paymentCond() {

        let label = ""

        if (this.customer.paymentCond == "weekly") {
          label = "Semanal"
        } else if (this.customer.paymentCond == "monthly") {
          label = "Quinzenal ou Mensal"
        } else {
          label = "Não definida"
        }

        return label
      },

      weeklyPaymentRule() {

        if (this.customer.paymentCond != "weekly" || !this.customer.weeklyPaymentRule)
          return ""

        const labels = {
          current: "Semana corrente",
          next: "Próxima semana",
          subsequent: "Semana subsequente",
        }

        return labels[this.customer.weeklyPaymentRule]
      },

      paymentDays() {

        if (!this.customer.paymentDays)
          return

        const days = this.customer.paymentDays.split(",")

        if (this.customer.paymentCond == "monthly")
          return days

        return days.map((day) => Calendar.labelOfWeek(day))
      },

      totalInvoiceable() {

        let value = 0

        for (const cert of this.certs) {
          if (cert.selected)
            value += cert.invoiceableValue
        }

        return value
      },

      receivablesTotal() {

        let total = 0

        this.receivables.forEach((receivable) => total += receivable.value)

        return total
      },

      hasAnticipation() {

        for (const cert of this.certs) {
          if (cert.anticipationValue)
            return true
        }

        return false
      },
    },

    methods: {

      loadReceivables() {

        const { paymentCond, paymentDays, weeklyPaymentRule, paymentPeriod } = this.customer

        if (!paymentCond || !paymentDays)
          return

        this.receivables = new PaymentCondition(
          paymentCond, 
          paymentDays, 
          this.totalInvoiceable, 
          weeklyPaymentRule, 
          paymentPeriod,
        ).generate()
        
        this.sortReceivables()
      },

      sortReceivables() {

        let receivables = this.receivables.slice()

        receivables.forEach((receivable, index) => {
          
          receivable.index = index
          receivable.sortKey = moment(receivable.dueDate).format("YYYYMMDD")
          receivable.weekDayLabel = moment(receivable.dueDate).format("dddd").toLowerCase()

          if (this.totalInvoiceable < 0 && receivable.value > 0)
            receivable.value = -receivable.value

        })

        this.receivables = _.sortBy(receivables, "sortKey")
      },

      onAddReceivable(receivable) {
        this.receivables.push(receivable)
        this.sortReceivables()
      },

      onUpdateReceivable(receivable) {

        let targetIndex = this.receivables.findIndex((el) => el.index == receivable.index)

        this.receivables[targetIndex] = receivable
        
        this.sortReceivables()
      },

      onRemoveReceivable($event, index) {

        $event.stopPropagation()

        this.receivables.splice(index, 1)
      },

      showCert($event, id) {
        
        $event.stopPropagation()

        AppBrowser.openNewTab(`/procs/certs/${id}/show`)
      },

      async onConfirm() {

        if (!this.validConfirmation())
          return

        this.saving = true

        try {

          const invoice = await this.service.create({
            date: moment().format("YYYY-MM-DD"),
            startDate: moment(this.filter.startDate).format("YYYY-MM-DD"),
            endDate: moment(this.filter.endDate).format("YYYY-MM-DD"),
            customerId: this.customer.id,
            value: this.totalInvoiceable,
            certIds: this.certs.map((cert) => cert.id),
            receivables: this.receivables,
          })

          this.$reloadDataTables(["customer-invoices"])

          this.$msg.success("Fechamento criado com sucesso")

          this.$router.push(`/financial/customer-invoices/${invoice.id}/show`)
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.saving = false
        }
      },

      validConfirmation() {

        if (!this.totalInvoiceable)
          return true

        let isOk = true

        if (this.receivablesTotal != this.totalInvoiceable) {
          isOk = false
          this.$msg.info("O valor total dos vencimentos é diferente do valor a receber")
        }

        return isOk
      },
    },
  }

</script>